import * as e from "zod";
//#region src/apiUrls.ts
var t = "https://product.api.myparcel.nl", n = "https://product.api.acceptance.myparcel.nl", r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var h = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, _ = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, ee = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, v = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (ee(t, n.name)) continue;
		let e = await h(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, y = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), b = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = S(e.headers, t.headers), n;
}, x = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, S = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? x(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, C = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, w = () => ({
	error: new C(),
	request: new C(),
	response: new C()
}), T = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), E = { "Content-Type": "application/json" }, D = (e = {}) => ({
	...r,
	headers: E,
	parseAs: "auto",
	querySerializer: T,
	...e
}), O = ((e = {}) => {
	let t = b(D(), e), n = () => ({ ...t }), r = (e) => (t = b(t, e), n()), a = w(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: S(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await v({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: y(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? _(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => y({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(D({
	baseUrl: "https://product.api.myparcel.nl",
	throwOnError: !0
})), k = e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }), A = e.enum(["status"]), j = e.uuid(), M = e.enum(["ACTIVE", "INACTIVE"]).register(e.globalRegistry, { description: "The status of the product." }), N = e.string().min(1).max(50), P = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "The sort direction." }), F = e.record(e.string(), e.object({
	free: e.int().gte(-9007199254740991).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of free stock of the product." }),
	value: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of stock of the product." })
})), I = e.object({
	id: j.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was created" }),
	name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
	shopIds: e.array(N).max(500).optional(),
	status: M,
	trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
	barcode: e.string().min(6).max(24).register(e.globalRegistry, { description: "The barcode of the product." }).optional(),
	children: e.array(e.object({
		id: j.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
		quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
	})).max(50).optional(),
	containsDangerousSubstances: e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." }).optional(),
	countryCodeOfOrigin: e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "The country code of origin of the product." }).optional(),
	descriptions: e.array(e.object({
		text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
		languageCode: e.string().length(2).register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
	})).min(1).max(200).register(e.globalRegistry, { description: "The descriptions of the product." }).optional(),
	dimensions: e.object({
		height: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.enum([
				"mm",
				"cm",
				"m"
			]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The height of the product." }),
		length: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.enum([
				"mm",
				"cm",
				"m"
			]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The length of the product." }),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
		}).register(e.globalRegistry, { description: "The weight of the product." }),
		width: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.enum([
				"mm",
				"cm",
				"m"
			]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The width of the product." })
	}).register(e.globalRegistry, { description: "The dimensions of the product." }).optional(),
	ean: e.string().register(e.globalRegistry, { description: "The EAN of the product." }).optional(),
	fulfilmentPlatforms: e.tuple([k]).register(e.globalRegistry, { description: "The fulfilment platforms the product is available on." }).optional(),
	hasUnlimitedShelfLife: e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." }).optional(),
	hsCode: e.string().min(6).max(10).register(e.globalRegistry, { description: "The HS code of the product." }).optional(),
	parents: e.array(j.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." }))).min(1).max(100).optional(),
	purchasePrice: e.object({
		currency: e.string().length(3),
		micros: e.int().gte(0).lte(9007199254740991)
	}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value." }).optional(),
	salesChannels: e.array(e.union([
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["bol"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["cscart"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["lightspeed"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["magento"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["presta"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["shopify"]),
			inventoryItemId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The inventory item ID in shopify." }).optional(),
			inventoryLocationId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The location id of the product in shopify" }).optional()
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["woocommerce"])
		})
	])).register(e.globalRegistry, { description: "References to the sales channels per e-commerce platform." }).optional(),
	salesPrice: e.object({
		currency: e.string().length(3),
		micros: e.int().gte(0).lte(9007199254740991),
		taxRate: e.int().gte(0).lte(100)
	}).register(e.globalRegistry, { description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value." }).optional(),
	sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional(),
	stock: F.optional(),
	updatedAt: e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was last updated." }).optional()
}), L = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), R = L.and(e.object({
	type: e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), z = e.object({
	body: e.object({
		name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
		sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.string().min(6).max(24).register(e.globalRegistry, { description: "The barcode of the product." }).optional(),
		children: e.array(e.object({
			id: j.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		})).max(50).optional(),
		containsDangerousSubstances: e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." }).optional(),
		countryCodeOfOrigin: e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "The country code of origin of the product." }).optional(),
		descriptions: e.array(e.object({
			text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().length(2).register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).min(1).max(200).register(e.globalRegistry, { description: "The descriptions of the product." }).optional(),
		dimensions: e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum([
					"mm",
					"cm",
					"m"
				]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum([
					"mm",
					"cm",
					"m"
				]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum([
					"mm",
					"cm",
					"m"
				]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).optional(),
		ean: e.union([e.string().length(8), e.string().length(13)]).optional(),
		hasUnlimitedShelfLife: e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." }).optional(),
		hsCode: e.string().min(6).max(10).register(e.globalRegistry, { description: "The HS code of the product." }).optional(),
		purchasePrice: e.object({
			currency: e.string().length(3),
			micros: e.int().gte(0).lte(9007199254740991)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value." }).optional(),
		salesPrice: e.object({
			currency: e.string().length(3),
			micros: e.int().gte(0).lte(9007199254740991),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value." }).optional(),
		shopIds: e.array(N).max(500).optional(),
		status: M.and(e.unknown()).optional(),
		fulfilmentPlatforms: e.tuple([k]).optional()
	}).register(e.globalRegistry, { description: "Body for creating a product." }),
	path: e.never().optional(),
	query: e.never().optional()
}), B = I, V = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregation: e.tuple([A]).register(e.globalRegistry, { description: "Fields to summarize data based on the query." }).optional(),
		filter: e.object({
			id: e.array(j).min(1).max(100).optional(),
			createdAt: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<datetime>\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:[+-][0-2]\d:[0-5]\d|Z))$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).min(1).max(2).optional(),
			countryCodeOfOrigin: e.array(e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."))).optional(),
			dangerousSubstances: e.enum(["true", "false"]).register(e.globalRegistry, { description: "The filter on dangerous substances." }).optional(),
			dimensionsVolume: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a (floating) number (12, 123.45)." })).min(1).max(2).optional(),
			salesPrice: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a floating number (123.45)." })).min(1).max(2).optional(),
			shopId: e.array(N).min(1).max(100).optional(),
			status: e.array(M).min(1).max(2).optional(),
			taxRate: e.array(e.string()).min(1).max(100).optional(),
			unlimitedShelfLife: e.enum(["true", "false"]).register(e.globalRegistry, { description: "The filter on unlimited shelf life." }).optional()
		}).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "The maximum number of products to retrieve." }).optional().default(50),
		query: e.string().min(1).max(500).register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		pageToken: e.string().min(4).max(500).register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		sort: e.object({
			barcode: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the barcode property." })).optional(),
			ean: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the ean property." })).optional(),
			name: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the name property." })).optional(),
			purchasePrice: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the purchase price property." })).optional(),
			salesPrice: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sales price property." })).optional(),
			sku: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sku property." })).optional(),
			status: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the status property." })).optional(),
			stock: P.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the stock property." })).optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `name` ascending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), te = e.object({
	results: e.array(I).min(0).max(50).register(e.globalRegistry, { description: "The list of products." }),
	total: e.object({
		relation: e.enum(["eq", "gte"]).register(e.globalRegistry, { description: "The relation of the total number of products." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of products." })
	}),
	aggregations: e.object({ status: e.tuple([e.object({
		key: M,
		count: e.int().gte(0)
	}), e.object({
		key: M,
		count: e.int().gte(0)
	})]).optional() }).optional(),
	nextPageToken: e.string().min(1).max(500).register(e.globalRegistry, { description: "The next page token to retrieve the next page of products." }).optional()
}).register(e.globalRegistry, { description: "The listed products." }), H = e.object({
	body: e.object({
		productIds: e.array(j).min(1).max(50).register(e.globalRegistry, { description: "The product ids to (un)manage inventory for." }),
		fulfilmentPlatforms: e.tuple([k]).register(e.globalRegistry, { description: "The fulfilment platforms to (un)manage inventory for." }).optional()
	}).register(e.globalRegistry, { description: "Body for (un)managing inventory of a product." }),
	path: e.never().optional(),
	query: e.never().optional()
}), U = e.void().register(e.globalRegistry, { description: "inventory is (un)managed by provided fulfilment platform." }), W = e.object({
	body: e.object({
		name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
		sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.string().min(6).max(24).register(e.globalRegistry, { description: "The barcode of the product." }).optional(),
		children: e.array(e.object({
			id: j.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		})).max(50).optional(),
		containsDangerousSubstances: e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." }).optional(),
		countryCodeOfOrigin: e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "The country code of origin of the product." }).optional(),
		descriptions: e.array(e.object({
			text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().length(2).register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).min(1).max(200).register(e.globalRegistry, { description: "The descriptions of the product." }).optional(),
		dimensions: e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum([
					"mm",
					"cm",
					"m"
				]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum([
					"mm",
					"cm",
					"m"
				]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum([
					"mm",
					"cm",
					"m"
				]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).optional(),
		ean: e.union([e.string().length(8), e.string().length(13)]).optional(),
		hasUnlimitedShelfLife: e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." }).optional(),
		hsCode: e.string().min(6).max(10).register(e.globalRegistry, { description: "The HS code of the product." }).optional(),
		purchasePrice: e.object({
			currency: e.string().length(3),
			micros: e.int().gte(0).lte(9007199254740991)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value." }).optional(),
		salesPrice: e.object({
			currency: e.string().length(3),
			micros: e.int().gte(0).lte(9007199254740991),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value." }).optional(),
		shopIds: e.array(N).max(500).optional(),
		status: M.and(e.unknown()).optional(),
		id: j.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." }))
	}).register(e.globalRegistry, { description: "Body for updating a product." }),
	path: e.never().optional(),
	query: e.never().optional()
}), G = I, K = e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }), q = e.union([e.enum(["status"]), e.string()]), J = e.uuid(), Y = e.union([e.enum(["ACTIVE", "INACTIVE"]), e.string()]).register(e.globalRegistry, { description: "The status of the product." }), X = e.string(), Z = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "The sort direction." }), ne = e.record(e.string(), e.object({
	free: e.int().gte(-9007199254740991).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of free stock of the product." }),
	value: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of stock of the product." })
})), Q = e.object({
	id: J.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was created" }),
	name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
	shopIds: e.array(X).optional(),
	status: Y,
	trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
	barcode: e.string().register(e.globalRegistry, { description: "The barcode of the product." }).optional(),
	children: e.array(e.object({
		id: J.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
		quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
	})).optional(),
	containsDangerousSubstances: e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." }).optional(),
	countryCodeOfOrigin: e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "The country code of origin of the product." }).optional(),
	descriptions: e.array(e.object({
		text: e.string().register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
		languageCode: e.string().register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
	})).register(e.globalRegistry, { description: "The descriptions of the product." }).optional(),
	dimensions: e.object({
		height: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.union([e.enum([
				"mm",
				"cm",
				"m"
			]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The height of the product." }),
		length: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.union([e.enum([
				"mm",
				"cm",
				"m"
			]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The length of the product." }),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
		}).register(e.globalRegistry, { description: "The weight of the product." }),
		width: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.union([e.enum([
				"mm",
				"cm",
				"m"
			]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The width of the product." })
	}).register(e.globalRegistry, { description: "The dimensions of the product." }).optional(),
	ean: e.string().register(e.globalRegistry, { description: "The EAN of the product." }).optional(),
	fulfilmentPlatforms: e.tuple([K]).register(e.globalRegistry, { description: "The fulfilment platforms the product is available on." }).optional(),
	hasUnlimitedShelfLife: e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." }).optional(),
	hsCode: e.string().register(e.globalRegistry, { description: "The HS code of the product." }).optional(),
	parents: e.array(J.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." }))).optional(),
	purchasePrice: e.object({
		currency: e.string(),
		micros: e.int().gte(0).lte(9007199254740991)
	}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value." }).optional(),
	salesChannels: e.array(e.union([
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["bol"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["cscart"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["lightspeed"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["magento"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["presta"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["shopify"]), e.string()]),
			inventoryItemId: e.string().register(e.globalRegistry, { description: "The inventory item ID in shopify." }).optional(),
			inventoryLocationId: e.string().register(e.globalRegistry, { description: "The location id of the product in shopify" }).optional()
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["woocommerce"]), e.string()])
		})
	])).register(e.globalRegistry, { description: "References to the sales channels per e-commerce platform." }).optional(),
	salesPrice: e.object({
		currency: e.string(),
		micros: e.int().gte(0).lte(9007199254740991),
		taxRate: e.int().gte(0).lte(100)
	}).register(e.globalRegistry, { description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value." }).optional(),
	sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional(),
	stock: ne.optional(),
	updatedAt: e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was last updated." }).optional()
});
e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}).and(e.object({
	type: e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), e.object({
	body: e.object({
		name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
		sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.string().register(e.globalRegistry, { description: "The barcode of the product." }).optional(),
		children: e.array(e.object({
			id: J.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		})).optional(),
		containsDangerousSubstances: e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." }).optional(),
		countryCodeOfOrigin: e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "The country code of origin of the product." }).optional(),
		descriptions: e.array(e.object({
			text: e.string().register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).register(e.globalRegistry, { description: "The descriptions of the product." }).optional(),
		dimensions: e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum([
					"mm",
					"cm",
					"m"
				]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum([
					"mm",
					"cm",
					"m"
				]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum([
					"mm",
					"cm",
					"m"
				]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).optional(),
		ean: e.union([e.string(), e.string()]).optional(),
		hasUnlimitedShelfLife: e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." }).optional(),
		hsCode: e.string().register(e.globalRegistry, { description: "The HS code of the product." }).optional(),
		purchasePrice: e.object({
			currency: e.string(),
			micros: e.int().gte(0).lte(9007199254740991)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value." }).optional(),
		salesPrice: e.object({
			currency: e.string(),
			micros: e.int().gte(0).lte(9007199254740991),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value." }).optional(),
		shopIds: e.array(X).optional(),
		status: Y.and(e.unknown()).optional(),
		fulfilmentPlatforms: e.array(K).optional()
	}).register(e.globalRegistry, { description: "Body for creating a product." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var re = Q;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregation: e.tuple([q]).register(e.globalRegistry, { description: "Fields to summarize data based on the query." }).optional(),
		filter: e.object({
			id: e.array(J).optional(),
			createdAt: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).optional(),
			countryCodeOfOrigin: e.array(e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()])).optional(),
			dangerousSubstances: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "The filter on dangerous substances." }).optional(),
			dimensionsVolume: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a (floating) number (12, 123.45)." })).optional(),
			salesPrice: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a floating number (123.45)." })).optional(),
			shopId: e.array(X).optional(),
			status: e.array(Y).optional(),
			taxRate: e.array(e.string()).optional(),
			unlimitedShelfLife: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "The filter on unlimited shelf life." }).optional()
		}).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "The maximum number of products to retrieve." }).optional().default(50),
		query: e.string().register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		pageToken: e.string().register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		sort: e.object({
			barcode: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the barcode property." })).optional(),
			ean: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the ean property." })).optional(),
			name: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the name property." })).optional(),
			purchasePrice: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the purchase price property." })).optional(),
			salesPrice: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sales price property." })).optional(),
			sku: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sku property." })).optional(),
			status: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the status property." })).optional(),
			stock: Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the stock property." })).optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `name` ascending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
});
var ie = e.object({
	results: e.array(Q).register(e.globalRegistry, { description: "The list of products." }),
	total: e.object({
		relation: e.union([e.enum(["eq", "gte"]), e.string()]).register(e.globalRegistry, { description: "The relation of the total number of products." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of products." })
	}),
	aggregations: e.object({ status: e.tuple([e.object({
		key: Y,
		count: e.int().gte(0)
	}), e.object({
		key: Y,
		count: e.int().gte(0)
	})]).optional() }).optional(),
	nextPageToken: e.string().register(e.globalRegistry, { description: "The next page token to retrieve the next page of products." }).optional()
}).register(e.globalRegistry, { description: "The listed products." });
e.object({
	body: e.object({
		productIds: e.array(J).register(e.globalRegistry, { description: "The product ids to (un)manage inventory for." }),
		fulfilmentPlatforms: e.tuple([K]).register(e.globalRegistry, { description: "The fulfilment platforms to (un)manage inventory for." }).optional()
	}).register(e.globalRegistry, { description: "Body for (un)managing inventory of a product." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var ae = e.void().register(e.globalRegistry, { description: "inventory is (un)managed by provided fulfilment platform." });
e.object({
	body: e.object({
		name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
		sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.string().register(e.globalRegistry, { description: "The barcode of the product." }).optional(),
		children: e.array(e.object({
			id: J.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." })),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		})).optional(),
		containsDangerousSubstances: e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." }).optional(),
		countryCodeOfOrigin: e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "The country code of origin of the product." }).optional(),
		descriptions: e.array(e.object({
			text: e.string().register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).register(e.globalRegistry, { description: "The descriptions of the product." }).optional(),
		dimensions: e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum([
					"mm",
					"cm",
					"m"
				]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum([
					"mm",
					"cm",
					"m"
				]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum([
					"mm",
					"cm",
					"m"
				]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).optional(),
		ean: e.union([e.string(), e.string()]).optional(),
		hasUnlimitedShelfLife: e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." }).optional(),
		hsCode: e.string().register(e.globalRegistry, { description: "The HS code of the product." }).optional(),
		purchasePrice: e.object({
			currency: e.string(),
			micros: e.int().gte(0).lte(9007199254740991)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value." }).optional(),
		salesPrice: e.object({
			currency: e.string(),
			micros: e.int().gte(0).lte(9007199254740991),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value." }).optional(),
		shopIds: e.array(X).optional(),
		status: Y.and(e.unknown()).optional(),
		id: J.and(e.unknown().register(e.globalRegistry, { description: "The ID of the product." }))
	}).register(e.globalRegistry, { description: "Body for updating a product." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var $ = Q, oe = (e) => (e.client ?? O).post({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await re.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-product",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), se = (e) => (e?.client ?? O).get({
	requestValidator: async (e) => await V.parseAsync(e),
	responseValidator: async (e) => await ie.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/products",
	...e
}), ce = (e) => (e.client ?? O).post({
	requestValidator: async (e) => await H.parseAsync(e),
	responseValidator: async (e) => await ae.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/manage-inventory",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), le = (e) => (e.client ?? O).post({
	requestValidator: async (e) => await W.parseAsync(e),
	responseValidator: async (e) => await $.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/update-product",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
//#endregion
export { O as C, F as S, t as T, A as _, k as a, N as b, z as c, U as d, W as f, I as g, R as h, le as i, B as l, L as m, oe as n, V as o, G as p, ce as r, te as s, se as t, H as u, j as v, n as w, P as x, M as y };
